export default function ProfileSetting() {
  return (
    <div className="flex flex-col gap-3 rounded-xl border border-white/10 bg-[#1F242A] p-6 text-white">
      <h2 className="text-xl font-semibold">Coming Soon</h2>
      <p className="text-sm text-white/70">
        Contact Customer Support to change personal information.
      </p>
    </div>
  );
}
